import { normalizeUser, type User } from '@/data'
import { buildQuery, type ListParams } from '@/api/client'
import api from '.'

export interface PaginatedUsers {
  data: User[]
  meta: {
    current_page: number
    last_page: number
    per_page: number
    total: number
  }
}

export async function getUsers(params?: ListParams): Promise<PaginatedUsers> {
  const res = await api.get('/', {
    params: buildQuery({ include: 'roles', ...params }),
  })
  return {
    data: res.data.data.map(normalizeUser),
    meta: res.data.meta,
  }
}
